
import React from 'react';
import Sidebar from '../../components/Sidebar';
import { Conversation, User, Language, AppMode } from '../../types';

interface SidebarTemplateProps {
  conversations: Conversation[];
  currentId: string | null;
  onSelect: (id: string) => void;
  onNewChat: () => void;
  onDelete: (id: string) => void;
  onClearAll?: () => void;
  onOpenSettings: () => void;
  onOpenPlans: () => void;
  onSwitchMode: (mode: AppMode) => void;
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  isOpen: boolean;
  onClose: () => void;
  user: User;
  onLogout?: () => void;
  language: Language;
  onSwitchLanguage: (lang: Language) => void;
}

const SidebarTemplate: React.FC<SidebarTemplateProps> = (props) => {
  return (
    <Sidebar 
      conversations={props.conversations}
      currentId={props.currentId}
      onSelect={props.onSelect}
      onNewChat={props.onNewChat}
      onDelete={props.onDelete}
      onClearAll={props.onClearAll}
      onOpenSettings={props.onOpenSettings}
      onOpenPlans={props.onOpenPlans}
      onSwitchMode={props.onSwitchMode}
      theme={props.theme}
      toggleTheme={props.toggleTheme}
      isOpen={props.isOpen}
      onClose={props.onClose}
      user={props.user}
      onLogout={props.onLogout}
      language={props.language}
      onSwitchLanguage={props.onSwitchLanguage}
    />
  );
};

export default SidebarTemplate;
